import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
} from '@angular/core';
import { ToastActionKind, ToastSeverity } from '@gh/core-ui';
import { stopEvent } from '@gh/core-util';
import { ToastItem } from './toast-item';

@Component({
  standalone: false,
  selector: 'gh-toast-card',
  templateUrl: 'toast-card.component.html',
  styleUrls: ['toast-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastCardComponent {
  @Input() item: ToastItem;

  get severity(): ToastSeverity {
    return this.item.config.severity;
  }

  get shortcutLabel(): string {
    const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);
    return isMac ? '⌘Z' : 'Ctrl+Z';
  }

  get showShortcut(): boolean {
    return !!(this.item.config.action && this.item.config.action.kind === ToastActionKind.Undo);
  }

  @HostListener('mouseenter')
  onEnter(): void {
    if (this.item.config.pauseOnHover !== false) {
      this.item.block();
    }
  }

  @HostListener('mouseleave')
  onLeave(): void {
    if (this.item.config.pauseOnHover !== false) {
      this.item.free();
    }
  }

  onClose(event: MouseEvent): void {
    stopEvent(event);
    this.item.close();
  }

  onAction(event: MouseEvent): void {
    stopEvent(event);
    if (this.item.config.action) {
      this.item.config.action.run();
    }
  }
}
